import loadable from 'react-loadable';
import ChunkErrorReloader from 'src/features/common/ChunkErrorReloader';

export default loadable({
  loader: () => import(/* webpackChunkName: "self-perform" */ './SelfPerform'),
  loading: ChunkErrorReloader,
});
